import { ZodIssue } from 'zod-validation-error';

export const getErrorKeys = (errors: ZodIssue[]): (string | number)[] => {
  return errors.flatMap(e => e.path);
};

export const removeKeysFromObject = <T extends object>(
  obj: T,
  pathsToRemove: (string | number)[]
): T => {
  return Object.keys(obj).reduce((result, key) => {
    if (!pathsToRemove.includes(key)) {
      result[key as keyof T] = obj[key as keyof T];
    }
    return result;
  }, {} as T);
};

export const deepCopy = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj));
};
